const main_path = '@/pages/user'

const UserRoutes = [
  {
    path: '/users',
    name: 'Users',
    meta: { 
      auth: true,
      needs_company: true,
      tab_name: 'Usuários',
      // roles: [Director, Manager, Supervisor],
    },
    component: () => import(`@/pages/user/Users`)
  },
  {
    path: '/users/:id',
    name: 'ShowUser',
    meta: { 
      auth: true,
      needs_company: true,
      tab_name: 'Usuários',
      // roles: [Director, Manager, Supervisor],
    },
    component: () => import(`@/pages/user/ShowUser`)
  },
  {
    path: '/new_user',
    name: 'CreateUser',
    meta: { 
      auth: true,
      needs_company: true,
      tab_name: 'Usuários',
      // roles: [Director, Manager, Supervisor],
    },
    component: () => import(`@/pages/user/CreateUser`) 
  },
]

export default UserRoutes
